<template>
	<div class="p-4" style="max-width:720px"> <!-- change size here -->
		<vue-plyr :options="options"> <!-- refer to the docs https://github.com/redxtech/vue-plyr -->
			<video controls	crossorigin	playsinline	data-poster="poster.jpg">
				<source size="576" src="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-1080p.mp4" type="video/mp4"/>
			</video>
		</vue-plyr>
	</div>
</template>

<script>
  export default {
		created() {app=this;},
		mounted() {}
	}
</script>